import React from 'react'
import { Container } from '@mui/material'
import { CONTENT_REFERENCE_FIELDS_YORE } from 'services/content-references/types'
import SectionAccordion from 'gui/components/accordion/section-accordion'
import ContentReferenceField from './content-references/ContentReferenceField'
import { useContentReferencesSection } from './useContentReferencesSection'
import type { SectionManagedSectionProps, ContentReferencesSectionContentData } from './types'

export type VideoContentReferencesYoreSectionContentData = ContentReferencesSectionContentData

export interface VideoContentReferencesYoreSectionProps extends SectionManagedSectionProps {
  contentData: ContentReferencesSectionContentData | null
}

/**
 * Video Content References of Yore Section (section-managed).
 * Legacy/deprecated reference types: conscious-format, conscious-topic, film-subject, film-type, recipe-diet, recipe-type, video-topic.
 * Uses useContentReferencesSection for state/mutations/save; renders via ContentReferenceField.
 *
 * Query dependency: This section expects contentData.contentReferencesFrom to include all types
 * in CONTENT_REFERENCE_FIELDS_YORE. The page's GraphQL query (GET_VIDEO_CONTENT in queries.ts)
 * must request contentReferencesFrom(types: [these types]). If the query omits them, existing refs
 * won't load and saved refs will disappear after refetch.
 */
function VideoContentReferencesYoreSection ({
  contentData,
  isViewOnly,
  onDirtyChange,
  saveHandlerRef,
  onResetTriggered,
}: VideoContentReferencesYoreSectionProps) {
  const refTypes = CONTENT_REFERENCE_FIELDS_YORE as string[]

  const { contentReferences, handleContentReferencesChange } = useContentReferencesSection({
    refTypes,
    contentData,
    onDirtyChange,
    saveHandlerRef,
    onResetTriggered,
  })

  return (
    <Container className="content-detail__section content-references-yore" maxWidth={false}>
      <SectionAccordion title="Content References of Yore" collapsed={true}>
        {refTypes.map((referenceType) => (
          <ContentReferenceField
            key={referenceType}
            referenceType={referenceType}
            value={contentReferences[referenceType] || []}
            onChange={(newReferences) =>
              handleContentReferencesChange(referenceType, newReferences)
            }
            disabled={isViewOnly}
          />
        ))}
      </SectionAccordion>
    </Container>
  )
}

export default VideoContentReferencesYoreSection
